<template>
    <component :is="pagemain" v-on="$listeners"></component>
</template>

<script>
    export default {
        name: 'index',
        computed: {
            pagemain: function () {

                let folder = this.$route.params.root || 'home';
                folder = folder.toLowerCase();

                let filename = this.$route.params.sub || folder;

                let isshowheaderfooter = !(folder == 'tdl' || folder == 'tp' || folder == 'tsr' || folder == 'tpl');//MS无用
                this.$emit('showheaderfooter', isshowheaderfooter);//MS无用
                this.$emit('hidepop');
                return () => import('@/views/' + folder + '/' + filename);
            }
        },
        mounted() {
            let folder = this.$route.params.root || 'home';
            folder = folder.toLowerCase();
            if (((folder == "course") || (folder == "member") || (folder == "tsr") || (folder == "tdl")) && (this.$store.state.islogin == 0)) {
                this.$router.replace('/');
            }
        }
    };
</script>
